import React, { useState } from 'react';
import './App.css';

function App() {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [showExplanation, setShowExplanation] = useState(false);
  const [answers, setAnswers] = useState([]);
  const [quizCompleted, setQuizCompleted] = useState(false);
  
  const questions = [
    {
      question: "Have you visually mapped your customers' journey from start to finish to identify all peaks and pits along the way?",
      explanation: "Mapping the journey helps you step into your customers' shoes, uncovering opportunities to improve their experience and address pain points."
    },
    {
      question: "Do you regularly collect and analyze customer feedback through surveys, reviews, or analytics?",
      explanation: "Feedback reveals what your customers love and where they encounter challenges, giving you the insights needed to continuously refine their experience."
    },
    {
      question: "Do you use a CRM system to organize customer data, streamline communication, and improve relationship management?",
      explanation: "A CRM is the backbone of your customer operations, helping you stay organized, work more efficiently, and deliver seamless, personalized experiences that build loyalty."
    },
    {
      question: "Have you defined and tracked key customer metrics like retention rates, acquisition costs, or satisfaction levels to measure performance over time?",
      explanation: "Tracking metrics helps you measure success, identify trends, and make smarter decisions to optimize the customer journey."
    },
    {
      question: "Do your team members understand your organization's strategy and values, and are they empowered to take action in real-time to create great customer experiences?",
      explanation: "The work behind the other questions only matters if your team brings it to life, delivering real value and great experiences to your customers."
    }
  ];

  const handleAnswer = (answer) => {
    setAnswers([...answers, { question: currentQuestionIndex, answer }]);
    setShowExplanation(true);
    
    // Schedule next question
    setTimeout(() => {
      if (currentQuestionIndex < questions.length - 1) {
        setCurrentQuestionIndex(currentQuestionIndex + 1);
        setShowExplanation(false);
      } else {
        setQuizCompleted(true);
      }
    }, 4000); // Show explanation for 4 seconds before next question
  };
  
  const calculateScore = () => {
    const yesAnswers = answers.filter(answer => answer.answer === 'yes').length;
    return yesAnswers;
  };
  
  const getResultFeedback = () => {
    const score = calculateScore();
    
    if (score === 5) {
      return "You're nailing it. Keep going! (Can I write a case study about your organization?)";
    } else if (score === 4) {
      return "You're doing well, but there's room to improve.";
    } else {
      return "Action needed. Let's tackle those gaps together.";
    }
  };
  
  const resetQuiz = () => {
    setCurrentQuestionIndex(0);
    setShowExplanation(false);
    setAnswers([]);
    setQuizCompleted(false);
  };
  
  // Current question to display
  const currentQuestion = questions[currentQuestionIndex];

  return (
    <div className="App">
      <div className="quiz-container">
        <h2>Customer Journey Assessment</h2>
        
        {!quizCompleted ? (
          <div className="question-section">
            <div className="progress-bar-container">
              <div className="progress-stats">
                <span>Question {currentQuestionIndex + 1} of {questions.length}</span>
                <span>{Math.round(((currentQuestionIndex) / questions.length) * 100)}% Complete</span>
              </div>
              
              <div className="progress-bar">
                <div 
                  className="progress-fill" 
                  style={{ width: `${(currentQuestionIndex / questions.length) * 100}%` }}
                ></div>
              </div>
            </div>
          
            <div className="question-content">
              <p className="question-text">{currentQuestion.question}</p>
              
              <div className="answer-buttons">
                <button onClick={() => handleAnswer('yes')}>Yes</button>
                <button onClick={() => handleAnswer('no')}>No</button>
              </div>
              
              {showExplanation && (
                <div className="explanation">
                  <p>{currentQuestion.explanation}</p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="results-section">
            <h3>How'd you do?</h3>
            <p className="score">{calculateScore()} / 5</p>
            <p className="feedback">{getResultFeedback()}</p>
            
            <div className="responses-list">
              <h4>Your Responses:</h4>
              {answers.map((answer, index) => (
                <div key={index} className="response-item">
                  <p className="response-question">{questions[answer.question].question}</p>
                  <div className="response-answer">
                    <span className={answer.answer === 'yes' ? 'yes' : 'no'}>
                      {answer.answer === 'yes' ? 'Yes' : 'No'}
                    </span>
                    <span className="response-explanation">{questions[answer.question].explanation}</span>
                  </div>
                </div>
              ))}
            </div>
            
            <button className="reset-button" onClick={resetQuiz}>
              Take Quiz Again
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;